import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setExtCustomColumnQuery = (payload) => ({
  type: actionTypes.SET_EXT_CUSTOM_COLUMN_QUERY,
  payload
});

export const getExtCustomColumnQueries = (params) => ({
  type: actionTypes.GET_EXT_CUSTOM_COLUMN_QUERIES,
  params
});

export const getExtCustomColumnQuery = (id) => ({
  type: actionTypes.GET_EXT_CUSTOM_COLUMN_QUERY,
  id
});

export const createExtCustomColumnQuery = (payload) => ({
  type: actionTypes.CREATE_EXT_CUSTOM_COLUMN_QUERY,
  payload
});

export const updateExtCustomColumnQuery = (payload) => ({
  type: actionTypes.UPDATE_EXT_CUSTOM_COLUMN_QUERY,
  payload,
});

export const deleteExtCustomColumnQuery = (Id) => ({
  type: actionTypes.DELETE_EXT_CUSTOM_COLUMN_QUERY,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});


export const setOpenModal = (isOpen) => ({
  type: actionTypes.SET_OPEN_MODAL,
  payload: isOpen,
});

export const updateExtCustomColumnQueriesOrder = (orderData) => ({
    type: actionTypes.UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER,
    payload: { orderData }
});